/**
 * @generated SignedSource<<5c91a2b1f0b918b45aa2ed66059e216e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerApplicationContactDetailsRefetchable_viewer$data = {
  readonly isCountryInEu: boolean | null;
  readonly " $fragmentType": "SellerApplicationContactDetailsRefetchable_viewer";
};
export type SellerApplicationContactDetailsRefetchable_viewer$key = {
  readonly " $data"?: SellerApplicationContactDetailsRefetchable_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationContactDetailsRefetchable_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "country"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./IsCountryInEuRefetchQuery.graphql')
    }
  },
  "name": "SellerApplicationContactDetailsRefetchable_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "country",
          "variableName": "country"
        }
      ],
      "kind": "ScalarField",
      "name": "isCountryInEu",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d784e6b3e75952e98a8545039445ce2f";

export default node;
